import { createFileRoute, redirect } from '@tanstack/react-router'
import { QUALITY_TABS } from '~/components/routes/quality/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/quality/')({
  staticData: {
    permission: { any: QUALITY_TABS.map((tab) => tab.permission) },
  },
  beforeLoad: ({ context }) => {
    const first = QUALITY_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )
    throw redirect({ to: first?.to ?? QUALITY_TABS[0].to })
  },
})
withRoutePermissions(Route)
